import gql from 'graphql-tag';

export const getCommDevice = gql`
	query($id: String, $deviceId: String) {
		getCommDevice(id: $id, deviceId: $deviceId) {
			id
			deviceId
			secondaryId
			archived
			destroyed
			lastCommunication
			pointOfSale {
				id
				assetId
				location {
					id
					name
				}
				place {
					id
					name
				}
			}
			commDeviceLayout {
				id
				items {
					id
					price
					row
					column
					selection
					salesSinceInit
					vendsSinceInit
				}
			}
		}
	}
`;
